import { PickupList, PickupListsRequest } from '../../../api/orders/pickuplist/pickupListTypes';

export type Status = 'loading' | 'ready';

export interface State {
  status: Status;
  pickupLists: PickupList[];
  appliedRequest: PickupListsRequest | null;
  downloadingId: string | null;
}

type ListsLoadingAction = { type: 'lists/loading', payload: PickupListsRequest };
type ListsLoadedAction = { type: 'lists/loaded', payload: PickupList[] };
type ListsFailedAction = { type: 'lists/failed' };
type DownloadStartedAction = { type: 'download/started', payload: string };
type DownloadFinishedAction = { type: 'download/finished' };

export type Action = ListsLoadingAction
| ListsLoadedAction
| ListsFailedAction
| DownloadStartedAction
| DownloadFinishedAction;

export const initialState: State = {
  status: 'loading',
  pickupLists: [],
  appliedRequest: null,
  downloadingId: null,
};

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'lists/loading': {
      return { ...state, status: 'loading', appliedRequest: action.payload };
    }
    case 'lists/loaded': {
      return { ...state, status: 'ready', pickupLists: action.payload };
    }
    case 'lists/failed': {
      return { ...state, status: 'ready', pickupLists: [] };
    }
    case 'download/started': {
      return { ...state, downloadingId: action.payload };
    }
    case 'download/finished': {
      return { ...state, downloadingId: null };
    }
    default:
      return state;
  }
}
